<template>
  <ConfigLayout current="store" :loading="busy">
    <ConfigPage title="連携設定" :gap="24" scrollable>
      <div class="section-group">
        <GnaviSync
          :gnaviSyncStatus="gnavi.displayStatus"
          :gnaviSyncType="gnavi.strategy"
          :resrakuSyncStatus="resraku.displayStatus"
          @fetch="fetch"
        />
        <PosSync :posSyncStatus="postas.displayStatus" :posSavedAuthKey="postas.savedAuthKey" @fetch="fetch" />
        <ResrakuSync
          :resrakuSyncStatus="resraku.displayStatus"
          :daichoAuthKey="resraku.daichoAuthKey"
          :savedResrakuAuthKey="resraku.savedResrakuAuthKey"
          :hasError="resraku.hasError"
          @fetch="fetch"
        />
        <PropertySection
          v-if="ivr.contract"
          title="電話自動受付予約（IVR）の設定"
          button="電話自動受付予約（IVR）設定"
          small
          @click="toIvr()"
        >
          <template #descSlot>
            <div class="desc">電話自動受付予約（IVR）の詳細設定が行えます。</div>
          </template>
        </PropertySection>
        <PropertySection title="他社取り込みの設定" button="他社取り込み設定" small @click="toMailconverion()">
          <template #descSlot>
            <div class="desc">他社取り込みの詳細設定が行えます。</div>
          </template>
        </PropertySection>
      </div>
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState } from 'vuex'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import PropertySection from '@/components/molecules/PropertySection'
import GnaviSync from './GnaviSync'
import PosSync from './PosSync'
import ResrakuSync from './ResrakuSync'

export default {
  name: 'Store',
  components: {
    ConfigLayout,
    ConfigPage,
    PropertySection,
    GnaviSync,
    PosSync,
    ResrakuSync,
  },
  computed: {
    ...mapState({
      sync: state => state.stores.sync,
      busy: state => state.stores.sync.busy,
    }),
    gnavi() {
      return this.sync.list.gnavi
    },
    postas() {
      return this.sync.list.postas
    },
    resraku() {
      return this.sync.list.resraku
    },
    ivr() {
      return this.sync.list.ivr
    },
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('stores/sync/get')
    },
    toIvr() {
      this.$router.push({ name: 'Ivr' })
    },
    toMailconverion() {
      this.$router.push({ name: 'MailConversionConfirm' })
    },
  },
}
</script>

<style lang="postcss" scoped>
.section-group {
  display: grid;
  grid-gap: 24px;
}

.section {
  >>> .button {
    padding: 0 12px;
    width: fit-content;
  }
}

>>> .desc {
  font-size: 13px;
}

>>> .grid {
  grid-template-columns: inherit;
  justify-content: space-between;
}

>>> .label {
  align-items: center;
  background: var(--dark-gray);
  box-sizing: border-box;
  color: var(--white);
  display: grid;
  font-weight: 600;
  height: 32px;
  justify-content: center;
  line-height: 1;
  min-width: 96px;
  padding: 0 16px;

  &.synced {
    background: inherit;
    border: solid 1px var(--dark-gray);
    color: inherit;
  }
}
</style>
